import { render } from "./PCPartidasActivasYRecientesLineaParaPaletizado.vue?vue&type=template&id=2a1a8bfa"
import script from "./PCPartidasActivasYRecientesLineaParaPaletizado.vue?vue&type=script&lang=js"
export * from "./PCPartidasActivasYRecientesLineaParaPaletizado.vue?vue&type=script&lang=js"

import "./PCPartidasActivasYRecientesLineaParaPaletizado.vue?vue&type=style&index=0&id=2a1a8bfa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__